import { useModal } from 'hooks'

// NOTE: hook that exposes confirm submit modal state
export const useConfirmSubmitModal = () => {
  const { handleClose, handleOpen, isOpen } = useModal()

  return {
    handleConfirmSubmitClose: handleClose,
    handleConfirmSubmitOpen: handleOpen,
    isConfirmSubmitOpen: isOpen,
  }
}
